import getApi from '../../api'

export const cancelTurn = (conversationUlid: string) =>
  getApi().post<void>(`/stats_assistant/conversations/${conversationUlid}/cancel`)
